<template>
    <div class="flex justify-center items-center w-full h-full ">

        <div class="w-1/6  hover:cursor-pointer h-full flex justify-center items-center ">
             <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-12 text-gray-500">
                <path
                    d="M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21" />
                <path d="m14 19.5 3-3 3 3" />
                <path d="M17 22v-5.5" />
                <circle cx="9" cy="9" r="2" />
            </svg>
        </div>
    </div>
    </template>